import axios from 'redaxios';
import $ from 'jquery';

// https://www.npmjs.com/package/@shopify/theme-sections/v/1.1.0
// import {unload, load, getInstances} from '../vendor/theme-scripts/theme-sections';
import * as sections from '../vendor/theme-scripts/theme-sections';

let bisSections = {};

const selectors = {
  quickShopButton: '[data-quick-shop]',
  quickShopContent: '[data-quick-shop-content]'
};

const classes = {
  loading: 'loading',
  success: 'has-success',
  hide: 'hide',
};


class KlaviyoBIS {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    this.section.closest(`[data-section-type="product"]`).addEventListener('theme:variant:change', (event) => this.updateFormVariant(event));

    this.section.querySelector(`[klaviyo-bis-btn]`).addEventListener(
      'click',
      function (evt) {
        evt.preventDefault();
        const klaviyoId = this.section.getAttribute(`data-klaviyo-id`);
        const productId = this.section.getAttribute(`data-product-id`);
        const variantId = this.section.getAttribute(`data-variant-id`);
        const email = this.section.querySelector(`[klaviyo-bis-email]`).value;

        const successEle = this.section.querySelector(`[klaviyo-bis-success]`);
        const errorEle = this.section.querySelector(`[klaviyo-bis-error]`);

        if( !this.isEmail(email) ) {
          successEle.classList.add( classes.hide );
          errorEle.classList.remove( classes.hide );
          return;
        }

        errorEle.classList.add( classes.hide );

        // Add to list manually
        // if( typeof( KlaviyoSubscribe ) === 'object' ) {
        //   if( $('#kForm').length ) {
        //     $('#kForm').remove();
        //   }
        //   var formHtml = '<form id="kForm" class="hide" ction="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">' + $form.html() + '</form>';
        //   $('body').append( formHtml );

        //    KlaviyoSubscribe.attachToForms('#kForm', {
        //      hide_form_on_success: true,
        //      success_message: "Thank you for signing up!!"
        //    });
        //   $('#kForm').find('[name="email"]').val(email);
        //   $('#kForm').submit();
        // }

        // Add to back in stock
        $.ajax({
          'type': 'POST',
          'url': 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          'data': {
            'a': klaviyoId,
            'email': email,
            'product': productId,
            'variant': variantId,
            'platform': 'shopify'
          },
          success: function(result){
            successEle.classList.remove( classes.hide );
            errorEle.classList.add( classes.hide );
          }
        });

        // const url = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
        // const formData = {
        //   'data': {
        //     'a': klaviyoId,
        //     'email': email,
        //     'product': productId,
        //     'variant': variantId,
        //     'platform': 'shopify'
        //   }
        // };
        // axios
        //   .post(url, formData, {
        //     // headers: {
        //     //   'X-Requested-With': 'XMLHttpRequest',
        //     //   'Content-Type': 'application/x-www-form-urlencoded',
        //     // },
        //   })
        //   .then(function (response) {
        //     console.log('response')
        //     console.log(response)
        //     successEle.classList.remove( classes.hide );
        //     errorEle.classList.add( classes.hide );
        //   })
        //   .catch(function (error) {
        //     console.log('error')
        //     console.warn(error);
        //   });
      }.bind(this)
    );
  }

  isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  updateFormVariant(event) {
    const variant = event.detail.variant;
    this.section.setAttribute(`data-variant-id`, `${variant.id}`);
  }
}

const klaviyoBIS = {
  onLoad() {
    bisSections[this.id] = [];
    const els = this.container.querySelectorAll(`[klaviyo-bis]`);
    els.forEach((el) => {
      bisSections[this.id].push(new KlaviyoBIS(el));
    });
  },
  onUnload: function () {
    bisSections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export {KlaviyoBIS, klaviyoBIS};
